import { FormattedMessage } from "react-intl";

const WorkIntake = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.workIntake.content.body"
                    defaultMessage="Create dynamic user-friendly forms to collect data, configure workflows with a drag-and drop editor, and set up queues to triage work."
                />
            </p>
        </div>
    );
};

export default WorkIntake;
